module.exports = __webpack_public_path__ + "img/roompad.7608e937.svg";